module.exports = __webpack_public_path__ + "img/2.a9e1fa4d.jpg";